module.exports = __webpack_public_path__ + "static/media/3221.6d8fd2eb.jpg";